<script>
export default {
  title: 'Assignment 3: sed and grep',
  starterId: 'assign3.zip'
}
</script>

<template>
  <section>

    <Readings :readings="[
      {
        title: '<cite>Your UNIX/LINUX: The Ultimate Guide (3rd Edition)</cite> Chapter 10'
      }
    ]"/>

    <article>
      <h2>Overview</h2>
      <p>This assignment will introduce you to and give you experience with two
        very powerful UNIX command line tools. Sed is a simple text editor, and
        grep is a very powerful filter.</p>
    </article>

    <article id="starter">
      <h2>Starter Code</h2>

      <p>
        Please download the starter code from above. It should contains a single folder
        called <code>images</code> which will be used for Part 2.
      </p>
    </article>

    <article>
      <h2>Part 1: Excited Speak</h2>
      <p>
        Using sed, create a filter that will turn a simple phrase into an
        excited phrase. It should turn every period (.) into an exclamation mark
        (!), and if the period was at the end of the line, it should replace it
        with two exclamation marks instead of just one.
      </p>
      <p>
        Bring your tutor a
        transcript showing this filter working on a variety of input.
      </p>
    </article>

    <article>
      <h2>Part 2: Date Reformat</h2>

      <p>
        You took over 100 pictures during your New Year's Eve Celebration, and
        you'd like to list them in chronological order for a slide show.
        Unfortunately, your camera named the images using an inconvenient
        convention: img_MM-DD-YY_XX.jpg. MM is the 0 padded month, DD is the 0
        padded day of the month, YY is the last 2 digits of the year 0 padded, and
        XX is the 0 padded nth picture taken that day. (example: On Jan 5, 2017,
        you took 3 images. They were named img_01-05-17-{00,01,02}.jpg. If you take
        over 100 images in one day, the XX will be 3 digits long.)
      </p>

      <p>
        You would like to rename them, so their alphabetical order coincides
        with their chronological order. Create a for loop which uses sed and mv to
        rename all your images in the following convention:
        newyears_YYYY-MM-DD_XXX.jpg. Notice that the 'nth picture of the day' field
        is now 3 digits long instead of just 2, and the year field is the full year
        rather than the last 2 digits. Assume the first two digits are 20.
      </p>

      <p>
        The <code>image</code> folder from starter code contains a set of file names
        matching the input which you can use for testing.
      </p>

      <p>
        Bring a transcript showing your results to your tutor for checkoff.
      </p>

    </article>

    <article>
      <h2>Checklist</h2>

      <article>
        <h3>Part 1</h3>
        <ul>
          <li>Student shows transcript for sed script and can explain how it works.</li>
        </ul>
      </article>

      <article>
        <h3>Part 2</h3>
        <ul>
          <li>Student shows transcript for for loop using sed to construct the new filenames.</li>
        </ul>
      </article>
    </article>
  </section>
</template>



// WEBPACK FOOTER //
// src/components/assignments/unix/GrepAndSed.vue